export enum Platform {
  LocalURL = 'http://127.0.0.1:1234',
  StagingURL = 'https://stag.platform.ryddm.com/',
  ProductionURL = 'https://platform.ryddm.com/',
}
